<template>
  <v-layout row justify-center>
    <v-dialog v-model="siteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-toolbar dark color="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Site Info</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="saveSite(false)" :disabled="customerID === null || !newSiteValid">Save</v-btn>
      </v-toolbar-items>
      </v-toolbar>
      <v-form ref="newSite" v-model="newSiteValid">
      <v-container>
      <v-layout row>
      <v-flex sm6>
        <v-card class="pa-2 ma-2">
        <v-subheader>Location Info</v-subheader>
        <v-autocomplete
        label="Customer" 
        v-model="customerID"
        :items="customerArray"
        item-text="name"
        item-value="key"
        :rules="[v => !!v || 'Customer is required']" 
        required>
        </v-autocomplete>
        <v-text-field 
        label="Site Name" 
        v-model="siteEditedItem.Name"
        :rules="[v => !!v || 'Name is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Address" 
        v-model="siteEditedItem.Address"
        :rules="[v => !!v || 'Address is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Town/City" 
        v-model="siteEditedItem.Town"
        :rules="[v => !!v || 'Town/City is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Post Code" 
        v-model="siteEditedItem.PostCode"
        :rules="[v => !!v || 'Post Code is required']" 
        required>
        </v-text-field>
        <!-- <v-text-field 
        label="Contact Name" 
        v-model="siteEditedItem.Contact"
        :rules="[v => !!v || 'Contact Name is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Mobile" 
        v-model="siteEditedItem.Mobile"
        :rules="[v => !!v || 'Mobile Name is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Landline" 
        v-model="siteEditedItem.Landline">
        </v-text-field>
        <v-text-field 
        label="Email" 
        v-model="siteEditedItem.Email"
        :rules="[v => !!v || 'Email Name is required']" 
        required>
        </v-text-field> -->
        </v-card>
        <v-card class="pa-2 ma-2">
          <v-subheader>Contacts Info</v-subheader>
          <v-alert
            :value="!newSiteValid"
            color="warning"
            icon="priority_high"
          >
            Site must be valid before you can add contacts
          </v-alert>
          <v-alert
            :value="newSiteValid"
            color="info"
            icon="info"
            outline
          >
            To assign an existing contact, find in table below, 'click' on them and assign via contact dialog.
          </v-alert>
          <v-layout row wrap>
          <v-switch
            v-model="showAllContacts"
            label="Show All Customer Contacts"
            color="primary"
            hide-details
          ></v-switch>
          <v-spacer></v-spacer>
          <v-btn @click="selectedKey = null; saveSite(true)" color="primary" small :disabled="!newSiteValid">Add New Contact</v-btn>
          </v-layout>
          <v-data-table :headers="headers" :items="filteredContacts" :pagination.sync="pagination">
            <template slot="items" slot-scope="props">
              <tr @click.stop="saveSite(true); selectedKey = props.item.key; contactDialog = true; selectedCustomer = props.item.Customer">
                <td>{{ props.item.Name }}</td>
                <td>{{ props.item.EmailAddress }}</td>
                <td>{{ props.item.Phone }}</td>
                <td>{{ props.item.Mobile }}</td>
                <td>
                  <v-tooltip bottom v-if="props.item.Fleet">
                    <v-chip slot="activator" small><v-icon>mdi-truck</v-icon></v-chip>
                    <span>Fleet</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.Comms">
                    <v-chip slot="activator" small ><v-icon>mdi-phone</v-icon></v-chip>
                    <span>Comms</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.Accounts">
                      <v-chip slot="activator" small><v-icon>mdi-cash-100</v-icon></v-chip>
                    <span>Accounts</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex sm6>
        <v-card class="pa-2 ma-2">
        <v-subheader>Opening times</v-subheader>
            <v-text-field
            label="Mon/Fri"
            v-model="siteEditedItem.MonFriOpening"
            mask="##:## - ##:##"
            ></v-text-field>
            <v-text-field
            label="Sat"
            v-model="siteEditedItem.SatOpening"
            mask="##:## - ##:##"
            ></v-text-field>
            <v-text-field
            label="Sun"
            v-model="siteEditedItem.SunFriOpening"
            mask="##:## - ##:##"
            ></v-text-field>
            <v-text-field
            label="Preferred Install Time"
            v-model="siteEditedItem.InstallTime"
            mask="##:## - ##:##"
            ></v-text-field>
            <v-text-field
            label="Avoid Times"
            v-model="siteEditedItem.AvoidTimes"
            mask="##:## - ##:##"
            ></v-text-field>
        </v-card>
        <v-card class="ma-2 pa-2">
            <v-subheader>Extra Info</v-subheader>
            <v-checkbox v-model="headOffice" label="Is Head Office?"></v-checkbox>
            <v-text-field
            label="Site Access Restrictions"
            v-model="siteEditedItem.Restrictions"
            ></v-text-field>
            <v-textarea
            label="Other Notes"
            v-model="siteEditedItem.Notes"
            ></v-textarea>
        </v-card>
      </v-flex>
      </v-layout>
      </v-container>
      </v-form>
    </v-card>
    </v-dialog>
     <contact-edit-dialog @getContacts="getContacts" :customer="selectedCustomer" :customers="customers" :contactDialog.sync="contactDialog" :contactID="selectedKey" :siteID="editedSite"></contact-edit-dialog>
    <!-- <contact-edit-dialog @getContacts="getContacts" :customer="customerID" :customers="customers" :contactDialog.sync="contactDialog" :siteID="editedSite" :contactID="null"></contact-edit-dialog> -->
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  props: ['siteDialog', 'siteID', 'customers', 'customer'],
  data () {
    return {
      siteEditedItem: {
        Name: ''
      },
      siteDefaultItem: {
        Name: ''
      },
      headOffice: false,
      newSiteValid: false,
      loading: false,
      customerID: null,
      customerArray: [],
      contacts: [],
      contactDialog: false,
      editedSite: null,
      selectedContacts: [],
      pagination: {
        sortBy: 'Customer',
        rowsPerPage: 5,
        page: 1,
        descending: false
      },
      originalHeadOfficeState: false,
      showAllContacts: false,
      selectedKey: null,
      selectedCustomer: null,
      headers: [
        {
          text: 'Name',
          value: 'Name'
        },
        {
          text: 'Email',
          value: 'EmailAddress'
        },
        {
          text: 'Phone',
          value: 'Phone'
        },
        {
          text: 'Mobile',
          value: 'Mobile'
        },
        {
          text: 'Type',
          value: 'Type',
          sortable: false
        }
      ]
    }
  },
  watch: {
    customerID (val) {
      this.siteEditedItem.Customer = val
      this.selectedCustomer = val
      this.$forceUpdate()
    },
    siteDialog (val) {
      if (val === true) {
        this.editedSite = this.siteID
        this.getSite()
        this.customerID = this.customer.id
        this.getContacts()
        this.customerArray = []
        for (let item in this.customers) {
          this.customerArray.push({key: item, name: this.customers[item].customerName})
        }
        this.customerArray.sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
        this.$refs.newSite.validate()
      }
    }
  },
  computed: {
    filteredContacts () {
      let filteredContacts = []
      for (let contact in this.contacts) {
        let thisContact = JSON.parse(JSON.stringify(this.contacts[contact]))
        if (this.customers[thisContact.Customer] !== undefined) {
          thisContact.customerName = this.customers[thisContact.Customer].customerName
          if (!this.showAllContacts) {
            if (thisContact.Site.indexOf(this.editedSite) !== -1) {
              filteredContacts.push(thisContact)
            }
          } else {
            filteredContacts.push(thisContact)
          }
        }
      }
      return filteredContacts
    }
  },
  methods: {
    close () {
      this.$emit('update:siteDialog', false)
    },
    getSite () {
      this.siteEditedItem = {}
      if (this.editedSite !== null) {
        this.loading = true
        fireStore.collection('Sites').doc(this.editedSite)
        .get()
        .then(doc => {
          this.siteEditedItem = doc.data()
          this.originalHeadOfficeState = this.customers[doc.data().Customer].headOffice == this.editedSite
          this.headOffice = this.customers[doc.data().Customer].headOffice == this.editedSite
          this.loading = false
        })
      } else {
        this.originalHeadOfficeState = false
        this.siteEditedItem = JSON.parse(JSON.stringify(this.siteDefaultItem))
        this.siteEditedItem.Customer = this.customerID
      }
    },
    getContacts () {
      this.contacts = []
      fireStore.collection('Contacts').where('Customer', '==', this.customerID).get()
      .then(snap => {
        this.selectedContacts = []
        snap.forEach(doc => {
          this.contacts.push({...doc.data(), key: doc.id})
          if (doc.data().Site && doc.data().Site.indexOf(this.editedSite) !== -1) {
            this.selectedContacts.push(doc.id)
          }
        })
      })
    },
    saveSite (addContact) {
      if (this.editedSite !== null) {
        fireStore.collection('Sites').doc(this.editedSite).set(this.siteEditedItem, {merge: true})
        .then(() => {
          this.$emit('getSites')
          if (addContact === false) {
            this.close()
          } else {
            this.contactDialog = true
          }
          this.saveHeadOffice(this.editedSite)
        })
      } else {
        this.siteEditedItem.Customer = this.customerID
        fireStore.collection('Sites').add(this.siteEditedItem)
        .then((docRef) => {
          this.siteEditedItem.id = docRef.id
          this.editedSite = docRef.id
          this.$emit('getSites')
          if (addContact === false) {
            this.close()
          } else {
            this.contactDialog = true
          }
          this.saveHeadOffice(docRef.id)
        })
      }
    },
    saveHeadOffice (site) {
      if (this.headOffice !== this.originalHeadOfficeState) {
        if (this.headOffice) {
          fireStore.collection('Customers').doc(this.siteEditedItem.Customer).set({headOffice: site}, {merge: true})
          .then(() => {
            this.$emit('setCustomer', {customer: this.siteEditedItem.Customer, headOffice: site})
          })
        } else {
          fireStore.collection('Customers').doc(this.siteEditedItem.Customer).set({headOffice: null}, {merge: true})
          .then(() => {
            this.$emit('setCustomer', {customer: this.siteEditedItem.Customer, headOffice: null})
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SiteEditDialog.vue?0af82170